import { environment } from 'src/environments/environment';
import { Validators } from '@angular/forms';
import { PasswordValidators } from 'ngx-validators';


export function getPasswordRules() {
  const validators = [];

  if (environment.passwordRules.minlength > 0) {
    validators.push({
      validator: Validators.minLength(environment.passwordRules.minlength),
      message: `${environment.passwordRules.minlength} caracteres`,
      rule: 'minlength'
    });
  }

  if (environment.passwordRules.minUppercaseCharacterRule > 0) {
    validators.push({
      validator: PasswordValidators.uppercaseCharacterRule(environment.passwordRules.minUppercaseCharacterRule),
      message: `${environment.passwordRules.minUppercaseCharacterRule} letra maiúscula`,
      rule: 'uppercaseCharacterRule',
    });
  }

  if (environment.passwordRules.minLowercaseCharacterRule > 0) {
    validators.push({
      validator: PasswordValidators.lowercaseCharacterRule(environment.passwordRules.minLowercaseCharacterRule),
      message: `${environment.passwordRules.minLowercaseCharacterRule} letra minúscula`,
      rule: 'lowercaseCharacterRule',
    });
  }

  if (environment.passwordRules.minDigitCharacterRule > 0) {
    validators.push({
      validator: PasswordValidators.digitCharacterRule(environment.passwordRules.minDigitCharacterRule),
      message: `${environment.passwordRules.minDigitCharacterRule} número`,
      rule: 'digitCharacterRule'
    });
  }

  if (environment.passwordRules.minSpecialCharacterRule > 0) {
    validators.push({
      validator: PasswordValidators.specialCharacterRule(environment.passwordRules.minSpecialCharacterRule),
      message: `${environment.passwordRules.minSpecialCharacterRule} caractere especial`,
      rule: 'specialCharacterRule'
    });
  }
  return validators;
}